module.exports = __webpack_public_path__ + "static/media/email.860c4592.gif";